import {Card} from "../../../cdx-models/Card";
import {Query} from "../../../cdx-models/utils/MakeModel";
import {addDays, toDateStr} from "../../../lib/date-utils";
import {SearchCategory} from "../search-types";

const getUpvotes = (): SearchCategory<number> => {
  const processSearchValue = (val: number) => {
    return {op: "cardUpvotes", compareOp: "gte", value: val} as Query<Card>["meta"];
  };
  return {
    label: "Upvotes",
    key: "upvotes",
    getSuggestions({input}) {
      if ("upvotes".startsWith(input)) {
        return [5, 10, 25, 50];
      } else {
        return [];
      }
    },
    valueToKey(content) {
      return content;
    },
    valuesToDbQuery(values, {forceOr}) {
      if (values.length === 1) return {meta: processSearchValue(values[0])};
      return {
        [forceOr ? "$or" : "$and"]: values.map((content) => ({
          meta: processSearchValue(content),
        })),
      };
    },
    renderSuggestion(content) {
      return `${content}+ upvotes`;
    },
    savedSearchLabel(content) {
      return {
        prio: 0,
        label: `with ${content}+ upvotes`,
      };
    },
  };
};

type DueKey = "dueNow" | "soon" | "due";

const getDueDate = (): SearchCategory<DueKey> => {
  const keys: Record<DueKey, {constraint: Query<Card>; label: string}> = {
    dueNow: {constraint: {dueDate: toDateStr(new Date())}, label: "due today"},
    soon: {
      constraint: {
        $and: [
          {dueDate: {op: "gte", value: toDateStr(new Date())}},
          {dueDate: {op: "lte", value: toDateStr(addDays(new Date(), 7))}},
        ],
      },
      label: "due within 7 days",
    },
    due: {constraint: {dueDate: {op: "neq", value: null}}, label: "with due date"},
  };

  const processSearchValue = (val: DueKey) => {
    return keys[val].constraint;
  };

  return {
    label: "Due Date",
    key: "dueDate",
    getSuggestions({input}) {
      if ("due".startsWith(input)) {
        return ["dueNow", "soon", "due"];
      } else {
        return [];
      }
    },
    valueToKey(content) {
      return content;
    },
    valuesToDbQuery(values, {forceOr}) {
      if (values.length === 1) return processSearchValue(values[0]);
      return {
        [forceOr ? "$or" : "$and"]: values.map((content) => processSearchValue(content)),
      };
    },
    renderSuggestion(content) {
      return keys[content].label;
    },
    savedSearchLabel(content) {
      return {
        prio: 0,
        label: keys[content].label,
      };
    },
  };
};

const metaCategories = [getUpvotes(), getDueDate()];

export default metaCategories;
